import ApiService from "@/core/services/ApiService";
import { CareerCompassAnswers, CareerCompassPayload } from "@/modern/types/careerCompass";

export const careerCompassService = {
  async fetch(): Promise<CareerCompassPayload> {
    const response = await ApiService.get("/career-compass");
    return response.data as CareerCompassPayload;
  },

  async submit(answers: CareerCompassAnswers): Promise<CareerCompassPayload> {
    const response = await ApiService.post("/career-compass", { answers } as any);
    return response.data as CareerCompassPayload;
  },
};
